// All alphanumeric characters
var RADIX = 36; // "i" is not guaranteed to be unique if the library is used multiple times on the page, so we
// introduce some entropy to lower the likelihood of collisions.
// This creates a random 3 character string (36 possibilities for each character, 36^3 possibilities
// for each 3 character string, 1/36^6 probability that two instances share the same seed).

var MIN = RADIX * RADIX;
var MAX = RADIX * RADIX * RADIX - 1;
var SEED = Math.floor(Math.random() * (MAX - MIN + 1) + MIN);
var i = 0;
export var identifier = function identifier() {
  // Increment "i" so it is unique with each call
  i += 1;
  return "__c11n_" + SEED.toString(RADIX) + i.toString(RADIX);
};